import React, { useEffect, useState } from "react";
import axios from "../axiosConfig";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";

const RoomList = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await axios.get("/rooms/all");
        setRooms(response.data);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.error(
            error.response.data.message || "Không tìm thấy phòng nào."
          );
          setError("Không tìm thấy phòng nào.");
          setRooms([]);
        } else {
          console.error("Error fetching rooms:", error);
          toast.error("Lỗi khi lấy danh sách phòng.");
        }
      } finally {
        setLoading(false);
      }
    };
    fetchRooms();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-8 text-xl text-blue-500">Đang tải...</div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Danh sách phòng</h1>
      <ToastContainer />
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {error && rooms.length === 0 && (
          <div className="text-center text-red-500">{error}</div>
        )}
        {rooms.map((room) => (
          <div
            key={room._id}
            className="bg-white shadow-lg rounded-2xl overflow-hidden transform transition-transform hover:scale-105 hover:shadow-2xl"
          >
            <Link to={`/house-list/${room._id}`}>
              {/* Image */}
              <img
                src={
                  room.images?.[0]?.url ||
                  "https://via.placeholder.com/400x250?text=No+Image"
                }
                alt={room.name}
                className="w-full h-48 object-cover"
              />

              {/* Content */}
              <div className="p-4">
                <h2 className="text-lg font-semibold mb-1 text-gray-800 line-clamp-1">
                  {room.name}
                </h2>

                {/* <p className="text-sm text-gray-600 line-clamp-2 mb-2">
                  {room.description || "Không có mô tả."}
                </p> */}

                <div className="text-sm text-gray-700 mb-1">
                  <strong>Giá:</strong>{" "}
                  <span className="text-red-500 font-medium">
                    {room.price.toLocaleString()} VND
                  </span>
                </div>

                <div className="text-sm mb-1">
                  <strong>Trạng thái:</strong>{" "}
                  <span className={room.status ? "text-green-600" : "text-red-600"}>
                    {room.status ? "Còn trống" : "Đã thuê"}
                  </span>
                </div>

                <div className="text-sm mb-1">
                  <strong>Số lượng còn lại:</strong> {room.room_quantity}
                </div>

                {/* <div className="flex items-center text-sm text-gray-600 gap-1 mt-2">
                  <FaLocationDot className="text-gray-500" />
                  <span className="line-clamp-1">
                    {room.address?.detail}, {room.address?.ward},{" "}
                    {room.address?.district}, {room.address?.city}
                  </span>
                </div> */}
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoomList;
